import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getChecklist, dismissChecklist } from '../../services/onboardingService';
import GetStartedChecklist from './GetStartedChecklist';
import styles from './Onboarding.module.css';

// Dashboard card: stays until all four steps are done or an admin dismisses it.
export default function ChecklistCard() {
  const { hasPermission } = useAuth();
  const allowed = hasPermission('manage_company_settings');
  const [checklist, setChecklist] = useState(null);

  useEffect(() => {
    if (allowed) getChecklist().then(setChecklist).catch(() => {});
  }, [allowed]);

  if (!checklist?.show) return null;

  const dismiss = () => {
    setChecklist(null);
    dismissChecklist().catch(() => {});
  };

  return (
    <div className={styles.dashboardCard}>
      <GetStartedChecklist items={checklist.items} onDismiss={dismiss} />
    </div>
  );
}
